/**
 * Returns the value of a cookie by name or undefined if the specified cookie
 * does not exist.
 *
 * @param name The name of the cookie.
 */
export function getCookie(name: string): string | undefined {
  let cookiePrefix = name + '=';

  let decodedCookie = decodeURIComponent(document.cookie);
  let cookies = decodedCookie.split(';'); // Split into individual cookies

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();

    if (cookie.startsWith(cookiePrefix)) {
      return cookie.substring(cookiePrefix.length, cookie.length);
    }
  }

  return undefined;
}

/**
 * Sets a cookie.
 *
 * @param name The name of the cookie to set.
 * @param value The value of the cookie.
 * @param options Options when setting the cookie.
 */
export function setCookie(name: string, value: string, options?: CookieOptions): void {
  const { maxAge, sameSite } = options || {};

  let newCookieSegments = [];
  newCookieSegments.push(`${name}=${value}`);

  if (maxAge !== undefined) {
    newCookieSegments.push(`max-age=${maxAge}`);
  }

  newCookieSegments.push('path=/');

  if (sameSite !== undefined) {
    newCookieSegments.push(`samesite=${sameSite}`);
  }

  document.cookie = newCookieSegments.join('; ');
}

type CookieOptions = {
  /**
   * The maximum age of the cookie in seconds or undefined if the cookie should
   * be a session cookie.
   */
  maxAge?: number;

  /**
   * The SameSite policy for the cookie or undefined if the policy should not be
   * specified.
   */
  sameSite?: 'none' | 'lax' | 'strict';
};
